import { GlBadge, GlLink, GlPopover } from '../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { helpPagePath } from '~/helpers/help_page_helper';
export default {
    name: 'WorkItemBoardViewPopover',
    helpPath: helpPagePath('user/work_items/saved_views'),
    components: {
        GlBadge,
        GlLink,
        GlPopover
    },
    props: {
        target: {
            type: Function,
            required: true
        }
    }
};
